var _defs, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 10080 5040",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6v3H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v1.5h6V3zm6 0H3v3H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m0-360 69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0-210 54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "d",
    xlinkHref: "#a",
    transform: "scale(2.1)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h10080v5040H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6 3m0-3L0 3",
    stroke: "#fff",
    strokeWidth: 0.6,
    clipPath: "url(#b)",
    transform: "scale(840)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6 3m0-3L0 3",
    stroke: "#e4002b",
    strokeWidth: 0.4,
    clipPath: "url(#c)",
    transform: "scale(840)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2520 0v2520M0 1260h5040",
    stroke: "#fff",
    strokeWidth: 840
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2520 0v2520M0 1260h5040",
    stroke: "#e4002b",
    strokeWidth: 504
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 2520,
    y: 3780
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 7560,
    y: 4200
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 6300,
    y: 2205
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 7560,
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 8680,
    y: 1869
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 8064,
    y: 2730
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnAu);
export default __webpack_public_path__ + "static/media/en-AU.35df496abee23fe4e0cfb50a4cb9f15e.svg";
export { ForwardRef as ReactComponent };